import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import React, { useState } from 'react';
import { toast } from 'react-toastify';

import DeactivateIcon from '../../../assets/Deactivate.png';
import { Impersonate } from '../../../pages/impersonate/impersonate';
import { changeDateFormate } from '../../../utils/dateFormat';
import { useDeactivateDelegateMutation } from '../delegateSlice';
import './delegateToHistory.scss';

export const DelegateToHistory = (props: any) => {
    const [isImpersonate, setIsImpersonate] = useState<boolean>(false);
    const [name, setName] = useState<string>('');
    const [oracleId, setOracleId] = useState<number>(0);
    const [diaDeActivate, setDiaDeActivate] = useState<boolean>(false);
    const [deActivateId, setDeActivateId] = useState<number>();
    const [updateDeactivate] = useDeactivateDelegateMutation();

    const dialogFuncMap = {
        diaDisqualify: setDiaDeActivate,
    };
    const onHideDiaDisqualify = () => {
        dialogFuncMap.diaDisqualify(false);
    };

    const deActivateClick = () => {
        const data = {
            delegateid: deActivateId,
            employeenumber: props?.loggedEmpNum,
        };
        updateDeactivate(data)
            .unwrap()
            .then((res: any) => {
                onHideDiaDisqualify();
                if (res.message === 'Success') toast.success('Save Success');
                else toast.error('Save Failed');
            })
            .then((error: any) => {
                console.log(error);
            });
    };

    const deactiateDia = (delegationId: number) => {
        setDiaDeActivate(true);
        setDeActivateId(delegationId);
    };

    const actionButtonBody = (rowData: any) => {
        return props.activeIndex === 1 ? (
            <Button
                label="Impersonate"
                className="btn-primary float-end"
                onClick={() => handleImpersonate(rowData.delegator_employee_number, rowData.delegated_from)}
            />
        ) : (
            <Button
                label="De-Activate"
                className="btn-secondary float-end"
                onClick={() => deactiateDia(rowData?.delegation_id)}
            />
        );
    };
    const handleImpersonate = (oracleId: number, userName: string) => {
        setIsImpersonate(true);
        setName(userName);
        setOracleId(oracleId);
    };
    const disqualifyDiaFooter = () => {
        return (
            <div className="text-center">
                <Button
                    className="btn-secondary me-3"
                    label="Cancel"
                    onClick={onHideDiaDisqualify}
                />

                <Button
                    className="btn-primary text-center"
                    label="De-Activate"
                    onClick={deActivateClick}
                />
            </div>
        );
    };

    const delegateEmployee = (rowData: any) => {
        return props.activeIndex === 0
            ? `${rowData.delegated_to} (${rowData.delegate_employee_number})`
            : `${rowData.delegated_from} (${rowData.delegator_employee_number})`;
    };

    const startDate = (rowData: any) => {
        return changeDateFormate(rowData?.start_date);
    };

    const endDate = (rowData: any) => {
        return changeDateFormate(rowData?.end_date);
    };

    return (
        <div>
            <div className='row'>
                <div className='col-12'>
                    <h4 className="mt-4">Delegate History</h4>
                </div>
                <div className='col-12' style={{marginTop:'2.5rem'}}>
                    <DataTable value={props?.delegateHistory?.data} responsiveLayout="scroll">
                        <Column
                            field="delegate_employee_number"
                            header={props.activeIndex === 1 ? 'Delegate From' : 'Delegate To'}
                            body={delegateEmployee}
                        />
                        <Column header="Start" body={startDate} />
                        <Column header="End" body={endDate} />
                        <Column body={actionButtonBody} />
                    </DataTable>
                    {isImpersonate && <Impersonate flag userName={name} userOracleId={oracleId} />}
                </div>
                {diaDeActivate ? (
                    <Dialog
                        visible={diaDeActivate}
                        style={{ width: '20vw' }}
                        onHide={() => onHideDiaDisqualify()}
                        footer={disqualifyDiaFooter}
                    >
                        <div className="text-center">
                            <div>
                                <img src={DeactivateIcon} alt={DeactivateIcon} />
                            </div>
                            <p>Are you sure you want to de-activate this delegation?</p>
                        </div>
                    </Dialog>
                ) : (
                    ''
                )}
            </div>
        </div>
    );
};
